import React from 'react'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

/**
 * PopMenu - A reusable popup menu component
 *
 * @param {HTMLElement} anchorEl - Element to anchor the menu to
 * @param {boolean} open - Whether the menu is open
 * @param {function} onClose - Callback when menu is closed
 * @param {array} items - Array of menu items with structure: { label, onClick }
 * @param {string} id - Unique ID for the menu
 */
const PopMenu = ({
  anchorEl,
  open,
  onClose,
  items = [],
  id = 'popup-menu',
}) => {
  const getAnchorWidth = () => {
    return anchorEl?.offsetWidth || 'auto'
  }

  return (
    <Menu
      id={id}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      transformOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
      slotProps={{
        paper: {
          style: {
            minWidth: getAnchorWidth(),
            maxWidth: 'fit-content',
          },
        },
      }}
    >
      {items.map((item, index) => (
        <MenuItem
          key={index}
          onClick={() => {
            item.onClick?.()
            onClose?.()
          }}
        >
          {item.label}
        </MenuItem>
      ))}
    </Menu>
  )
}

export default PopMenu
